/* eslint-disable */
import React, { useContext, useState } from "react";

import { AtIcon, IconPhone, PencilIcon } from "../../common/icons";
import { useGetCustomerDetailsQuery, useUpdateCustomerInfoMutation } from "../../store/userSlice";
import { AddressForm } from "../../components/AddressLocation";
import { UpdateCustomerRequest } from "../../models/request/updateCustomerRequest";
import { LocalizationContext } from "../../App";

const Profile = () => {
  const { data: profile } = useGetCustomerDetailsQuery();
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({ profile });
  const [addressFormData, setAddressFormData] = useState({});
  const l10n = useContext(LocalizationContext);
  const [updateCustomerInfo, { isLoading, isSuccess }] = useUpdateCustomerInfoMutation();

  const toggleEdit = () => {
    setIsEditing(!isEditing);
  };

  const handleAddressFormChange = (updatedData: any) => {
    setAddressFormData(updatedData);
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    // TODO: setFormData((prevFormData) => ({
    //   ...prevFormData,
    //   profile: {
    //     ...prevFormData.profile,
    //     [name]: value,
    //   },
    // }));
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsEditing(false);
  };

  const handleConfirm = () => {
    if (isEditing) {
      const updatedProfile = {
        ...formData.profile,
        locationAddress: addressFormData,
      };

      const aggregatedData = {
        ...formData,
        profile: updatedProfile,
      };

      const updateCustomerRequest = new UpdateCustomerRequest(aggregatedData.profile);
      updateCustomerInfo(updateCustomerRequest);
    }
  };

  if (!profile) return <>Oops!</>;

  const displayForm = (
    <div className="card relative">
      {/* <div className="card-header pb-0 justify-end">
        <span className="flex text-lg font-semibold leading-none items-center">
          {profile.fullName}
        </span>
        <button className="" onClick={toggleEdit}>
          <PencilIcon className="w-5 h-5" />
        </button>
      </div> */}
      <div className="card-body flex flex-col gap-3">
        <AddressForm
          isPreviewMode={true}
          inputAddressData={profile.locationAddress}
          onChange={handleAddressFormChange}
        />
        <div className="flex items-center gap-4">
          <IconPhone className={"w-5 h-5 stroke-2 stroke-card"} />
          <span className="text-card">{profile.phone.replace(/\s/g, "")}</span>
        </div>
        <div className="flex items-center gap-4">
          <AtIcon className={"w-5 h-5 stroke-2 fill-card"} />
          <span className="text-card">{profile.email}</span>
        </div>
      </div>
    </div>
  );

  const editableForm = (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-1 mt-3 mx-4 flex-row items-center justify-between">
        <span className="flex flex-row text-black text-lg font-semibold leading-9 items-center"></span>
        <button
          aria-label="Edit profile"
          className="p-2"
          onClick={toggleEdit}
          type="button"
        >
          <PencilIcon className="w-5 h-5" />
        </button>
      </div>
      <div>
        <AddressForm
          inputAddressData={profile.locationAddress}
          isPreviewMode={false}
          onChange={handleAddressFormChange}
        />
      </div>
      <div className="form-group">
        <label htmlFor="firstName">{l10n.label.firstName}</label>
        <input
          className="form-control"
          id="firstName"
          name="firstName"
          onChange={handleChange}
          required
          type="text"
          value={formData?.profile?.firstName}
        />
      </div>
      <div className="form-group">
        <label htmlFor="lastName">{l10n.label.lastName}</label>
        <input
          className="form-control"
          id="lastName"
          name="lastName"
          onChange={handleChange}
          required
          type="text"
          value={formData?.profile?.lastName}
        />
      </div>
      <div className="form-group">
        <label htmlFor="phone">{l10n.label.phone}</label>
        <input
          className="form-control"
          id="phone"
          name="phone"
          onChange={handleChange}
          required
          type="tel"
          value={formData?.profile?.phone}
        />
      </div>
      <div className="form-group">
        <label htmlFor="email">{l10n.label.email}</label>
        <input
          className="form-control"
          id="email"
          name="email"
          readOnly
          required
          type="email"
          value={formData?.profile?.email}
        />
      </div>
    </form>
  );

  if (!profile) return <>Oops!</>;

  return (
    <>
      <h2>
        {l10n.title.welcome}
        {profile.fullName && (
          <>
            <span>,{" "}</span>
            <span className="font-semibold">{profile.fullName}</span>
          </>
        )}
      </h2>

      {isEditing ? editableForm : displayForm}

      {isEditing && (
        <button onClick={handleConfirm} className="btn btn-primary">
          {l10n.btn.confirmDetails}
        </button>
      )}
    </>
  );
};

export default Profile;
